import axios from './../../config/axios';

function find(id) {
    return axios().get(`/purchase/landed-costs/${id}`);
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    return axios().get(`/purchase/landed-costs`, { params });
}

function store(data) {
    return axios().post(`/purchase/landed-costs`, data);
}

function update(id, data) {
    return axios().put(`/purchase/landed-costs/${id}`, data);
}

function remove(id) {
    return axios().delete(`/purchase/landed-costs/${id}`);
}

function post(id) {
    return axios().put(`/purchase/landed-costs/${id}/post`);
}

function print(id) {
    return axios().get(`/purchase/landed-costs/${id}/print`);
}

function states() {
    return axios().get(`/purchase/landed-cost-states`)
}

export default {
    index,
    store,
    update,
    find,
    remove,
    post,
    print,
    states
}